import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const cookieModalSettingsVars: MotifComponentProps<MotifComponent.COOKIE_MODAL_SETTINGS> = {
  '--cookie-modal-body-inline-padding': m('--spacing-xs'),
  '--cookie-modal-border-color': 'rgba(0, 0, 0, 0.2)',
  '--cookie-modal-border-radius': m('--border-radius-m'),
  '--cookie-modal-border-width': m('--border-width-xs'),
  '--cookie-modal-box-shadow': m('--box-shadow-l'),
  '--cookie-modal-logo-opacity': '1',
  '--cookie-modal-min-width': 'auto',
  '--cookie-modal-desktop-horizontal-padding': m('--spacing-xl'),
  '--cookie-modal-desktop-vertical-padding': m('--spacing-l'),
  '--cookie-modal-mobile-horizontal-padding': m('--spacing-s'),
  '--cookie-modal-mobile-vertical-padding': m('--spacing-xs'),
  '--cookie-modal-rich-text-title-desktop-font-size': '1.17em',
  '--cookie-modal-rich-text-title-desktop-font-line-height': m('--h3-desktop-font-line-height'),
  '--cookie-modal-rich-text-title-desktop-font-weight': '500',
  '--cookie-modal-rich-text-title-desktop-font-stretch': m('--h3-desktop-font-stretch'),
  '--cookie-modal-rich-text-title-mobile-font-size': '1.17em',
  '--cookie-modal-rich-text-title-mobile-font-line-height': m('--h3-mobile-font-line-height'),
  '--cookie-modal-rich-text-title-mobile-font-weight': '500',
  '--cookie-modal-rich-text-title-mobile-font-stretch': m('--h3-mobile-font-stretch'),
  '--cookie-modal-rich-text-base-desktop-font-size': m('--text-desktop-font-size'),
  '--cookie-modal-rich-text-base-desktop-font-line-height': '26px',
  '--cookie-modal-rich-text-base-desktop-font-weight': '400',
  '--cookie-modal-rich-text-base-desktop-font-stretch': 'normal',
  '--cookie-modal-rich-text-base-mobile-font-size': m('--text-mobile-font-size'),
  '--cookie-modal-rich-text-base-mobile-font-line-height': '26px',
  '--cookie-modal-rich-text-base-mobile-font-weight': '400',
  '--cookie-modal-rich-text-base-mobile-font-stretch': 'normal',
  '--cookie-settings-box-shadow': m('--box-shadow-l'),
  '--cookie-settings-max-width': '100%',
  '--cookie-settings-border-width': m('--border-width-xs'),
  '--cookie-settings-padding': m('--spacing-m'),
  '--cookie-settings-category-border-color': m('--neutral-v100'),
  '--cookie-settings-category-border-radius': m('--border-radius-m'),
  '--cookie-settings-category-border-width': m('--border-width-xs'),
  '--cookie-settings-category-padding': m('--spacing-s'),
  '--cookie-settings-category-title-desktop-font-size': m('--p1-desktop-font-size'),
  '--cookie-settings-category-title-desktop-font-line-height': m('--p1-desktop-font-line-height'),
  '--cookie-settings-category-title-desktop-font-weight': m('--p1-desktop-font-weight'),
  '--cookie-settings-category-title-desktop-font-stretch': m('--p1-desktop-font-stretch'),
  '--cookie-settings-category-title-mobile-font-size': m('--p1-mobile-font-size'),
  '--cookie-settings-category-title-mobile-font-line-height': m('--p1-mobile-font-line-height'),
  '--cookie-settings-category-title-mobile-font-weight': m('--p1-mobile-font-weight'),
  '--cookie-settings-category-title-mobile-font-stretch': m('--p1-mobile-font-stretch'),
  '--cookie-settings-category-description-desktop-font-size': m('--text-desktop-font-size'),
  '--cookie-settings-category-description-desktop-font-line-height': '26px',
  '--cookie-settings-category-description-desktop-font-weight': m('--text-desktop-font-weight'),
  '--cookie-settings-category-description-desktop-font-stretch': 'normal',
  '--cookie-settings-category-description-mobile-font-size': m('--text-mobile-font-size'),
  '--cookie-settings-category-description-mobile-font-line-height': '26px',
  '--cookie-settings-category-description-mobile-font-weight': m('--text-mobile-font-weight'),
  '--cookie-settings-category-description-mobile-font-stretch': 'normal',
};

export const cookieModalSettingsDarkVars: MotifComponentProps<MotifComponent.COOKIE_MODAL_SETTINGS> =
  {
    ...cookieModalSettingsVars,
    '--cookie-settings-category-border-color': m('--neutral-v500'),
  };
